import React from 'react'
import LoadingIconFull from './loadingIconFull'
import { isTranspondBootLoaderHost } from './loadingIconFullHosts'

export default function LoadingOverlay() {
    const useTranspondLoader = typeof window !== 'undefined' && isTranspondBootLoaderHost(window.location.host)

    if (useTranspondLoader) {
        return (
            <div className='initialLoad'>
                <div className='loadingIconFullHost'>
                    <LoadingIconFull />
                </div>
            </div>
        )
    }

    return (
        <div className='initialLoad'>
            <div className='sk-chase'>
                <div className='sk-chase-dot'></div>
                <div className='sk-chase-dot'></div>
                <div className='sk-chase-dot'></div>
                <div className='sk-chase-dot'></div>
                <div className='sk-chase-dot'></div>
                <div className='sk-chase-dot'></div>
            </div>
        </div>
    )
}
